import { fromJS } from 'immutable';

export function request(state) {
    return state.set('liveGames', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { liveGames, groupedByCategories }) {
    return state.set('liveGames', fromJS({
        status: 'FINISHED',
        items: liveGames,
        groupedByCategories
    }));
}

export function error(state) {
    return state.set('liveGames', fromJS({
        status: 'ERROR'
    }));
}

